import { postRequest} from '../libs/AxiosService.util';

export async function serviceGetAssociatedRoles(params) {
    return await postRequest('roles/associated/employees', params);
}

export async function servicPostEmployeesRole(params) { 
    return await postRequest('roles/associate/employees', params);
}
export async function serviceAssociatedEmployeesDelete(params) { 
    return await postRequest('roles/associated/employees/delete', params);
}